export const isNotValidated = (row) =>
  row.validated === false || (row.validated === undefined && Number(row.gross_value) === 0);

export const isNotAdvancing = (row) => Boolean(row.is_checked) && !row.can_advance;

// Recusa total (B1a): todos os plantões em "Não antecipar" → o envio encerra o pacote como recusado.
export const isTotalRefusal = (rows) => rows.length > 0 && rows.every(isNotAdvancing);

// Plantões da janela (b): os marcados; se o BE pediu motivo e nenhum está marcado aqui, os que ele conta (can_advance = false).
export const refusedRows = (rows) => {
  const marked = rows.filter(isNotAdvancing);
  return marked.length ? marked : rows.filter((r) => !r.can_advance);
};

// Aviso do topo e marcação da linha: mesmo critério da lista (AB D19) — quem já está como
// "Não antecipar" não conta como pendência de valor (Ruling P5).
export const warnsNotValidated = (row) => isNotValidated(row) && !isNotAdvancing(row);

export const isConferred = (row) =>
  Boolean(row.verified_documents && row.can_advance && row.is_checked && row.normal_payment_date);

export const situationOf = (row) => {
  if (isNotAdvancing(row)) return "no";
  if (isConferred(row)) return "ok";
  if (isNotValidated(row)) return "review";
  return "pending";
};

export const SITUATION_LABEL = {
  no: "Não será antecipado agora",
  ok: "✓ Conferido",
  review: "Revisar valor",
  pending: "Pendente",
};

export const summarize = (rows) => ({
  conferred: rows.filter((r) => !isNotAdvancing(r) && isConferred(r)).length,
  notAdvancing: rows.filter(isNotAdvancing).length,
});

export const BULK_ACTIONS = {
  conferAndRelease: { verified_documents: true, can_advance: true, is_checked: true },
  notAdvance: { can_advance: false, is_checked: true },
};

export const buildBulkItems = (ids, patch) => ids.map((id) => ({ id, ...patch }));

export const applyItems = (rows, items) => {
  const byId = new Map(items.map((item) => [item.id, item]));
  return rows.map((row) => (byId.has(row.id) ? { ...row, ...byId.get(row.id) } : row));
};

export const sendSummary = (rows) => {
  const go = rows.filter((r) => !isNotAdvancing(r));
  const no = rows.filter(isNotAdvancing);
  return {
    go,
    no,
    goValue: go.reduce((acc, r) => acc + Number(r.real_net_value || 0), 0),
    goNotValidated: go.filter(isNotValidated),
    goWithoutDate: go.filter((r) => !r.normal_payment_date),
    // Mesmo critério do BE (MISSING_NORMAL_PAYMENT_DATE): liberado + documentos verificados sem data barra o envio.
    blockedWithoutDate: go.filter((r) => r.verified_documents && !r.normal_payment_date),
  };
};
